import { hexToRgba } from '@chronosphereio/core';
import { keyframes, styled } from '@mui/material';
import { CommonDataProps, combineSx, SxProps } from '../../utils';
import { Box } from '../Box';

interface LoadingBarProps extends CommonDataProps {
  sx?: SxProps;
  width?: string | number;
}

export const LoadingBar = ({ width, sx, 'data-testid': dataTestId, 'data-trackid': dataTrackId }: LoadingBarProps) => {
  return (
    <Box
      role="progressbar"
      data-testid={dataTestId}
      data-trackid={dataTrackId}
      sx={combineSx({ overflow: 'hidden', width }, sx)}
    >
      <Bar />
    </Box>
  );
};

export const LOADING_BAR_HEIGHT = 2;
const LOADING_BAR_WIDTH = 30;
const MAX_TRANSLATE_X = (100 / LOADING_BAR_WIDTH) * 100;
const ANIMATION_DELAY_MS = 300;

const animation = keyframes`
  0% {
    transform: translateX(-100%)
  }

  50% {
    transform: translateX(${MAX_TRANSLATE_X / 2}%)
  }

  100% {
    transform: translateX(${MAX_TRANSLATE_X}%)
  }
`;

const Bar = styled('div')(({ theme }) => {
  const barColor = theme.featureFlags.panwRebrandStubYear
    ? theme.palette.interactive.highlight.default
    : theme.palette.primary.main;
  return {
    height: `${LOADING_BAR_HEIGHT}px`,
    width: `${LOADING_BAR_WIDTH}%`,
    background: `linear-gradient(90deg, ${hexToRgba(barColor, 0.35)} 0%, ${hexToRgba(barColor, 0.66)} 35%, ${hexToRgba(barColor)} 100%)`,
    transform: 'translateX(-100%)',
    animation: `${animation} 1.8s linear infinite`,
    animationDelay: `${ANIMATION_DELAY_MS}ms`,
  };
});
